import React, { useState } from "react";

const DragAndDropDiv = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setPosition({
      x: e.clientX - e.target.offsetLeft,
      y: e.clientY - e.target.offsetTop,
    });
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      e.preventDefault();
      const newLeft = e.clientX - position.x;
      const newTop = e.clientY - position.y;
      e.target.style.left = `${newLeft}px`;
      e.target.style.top = `${newTop}px`;
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  return (
    <div
      style={{
        position: "absolute",
        width: "100px",
        height: "100px",
        backgroundColor: "lightblue",
        cursor: "grab",
        bottom: 0,
        zIndex: 9999,
      }}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      Drag Me
    </div>
  );
};

export default DragAndDropDiv;
